import Vue from 'vue'
import Router from 'vue-router'

import store from './store'

// Components
import Gate from './views/Gate'
import Entry from './views/Entry'
import Rules from './views/Rules'
import Success from './views/Success'
import Rejected from './views/Rejected'
import Fulfillment_Success from './views/Fulfillment_success'
import Failed from './views/Failed'
import Before_start from './views/Before_start'
import Ended from './views/Ended'
import Sweepstakes_selection from './views/Sweepstakes_selection'
import Game_play_regular from './views/Game_play_regular'
import Instant_win_approval from './views/Instant_win_approval'
import Winner_form from './views/Winner_form'
import Doe_form from './views/Doe_form'
import Download_page from './views/Download_page'

import Fulfillment from './views/Fulfillment'
import Fulfillment_upload_page from './views/Fulfillment_upload_page'

import End_point from './views/End_point'
import Sorry from './views/Sorry'
import Time_passed from './views/Time_passed'

import Animation from './views/Animation'
import Scratch from './views/Scratch'


Vue.use(Router)

const router =  new Router({
  routes: [
      {
        path: '/',
        name: 'root'
      },
      {
          path: '/before_start',
          name: 'before_start',
          component: Before_start
      },
      {
          path: '/ended',
          name: 'ended',
          component: Ended
      },
      {
          path: '/gate',
          name: 'gate',
          component: Gate
      },
      {
        path: '/entry',
        name: 'entry',
        component: Entry
      },
      {
          path: '/rules',
          name: 'rules',
          component: Rules
      },
      {
          path: '/rejected',
          name: 'rejected',
          component: Rejected,
      },
      {
          path: '/success',
          name: 'success',
          component: Success,
      },
      {
        path: '/fulfillment_success',
        name: 'fulfillment_success',
        component: Fulfillment_Success,
      },
      {
          path: '/failed',
          name: 'failed',
          component: Failed,
      },
      {
          path: '/sweepstakes_selection',
          name: 'sweepstakes_selection',
          component: Sweepstakes_selection,
      },
      {
          path: '/game',
          name: 'game_play_regular',
          component: Game_play_regular,
      },
      {
          path: '/animation',
          name: 'animation',
          component: Animation,
      },
      {
          path: '/scratch',
          name: 'scratch',
          component: Scratch,
      },
      {
          path: '/instant_win_approval',
          name: 'instant_win_approval',
          component: Instant_win_approval,
      },
      {
          path: '/winner_form',
          name: 'winner_form',
          component: Winner_form,
      },
      {
          path: '/doe_form',
          name: 'doe_form',
          component: Doe_form,
      },
      {
          path: '/download_page',
          name: 'download_page',
          component: Download_page,
      },
    // Fulfillment
      {
          path: '/fulfillment',
          name: 'fulfillment',
          component: Fulfillment,
      },
      {
          path: '/fulfillment_reward_acceptance',
          name: 'fulfillment_reward_acceptance',
          component: Instant_win_approval,
      },
      {
          path: '/fulfillment_winner_form',
          name: 'fulfillment_winner_form',
          component: Winner_form,
      },
      {
          path: '/fulfillment_doe_form',
          name: 'fulfillment_doe_form',
          component: Doe_form,
      },
      {
          path: '/fulfillment_upload_page',
          name: 'fulfillment_upload_page',
          component: Fulfillment_upload_page,
      },

      {
          path: '/thank_you',
          name: 'end_point',
          component: End_point,
      },
      {
          path: '/sorry',
          name: 'sorry',
          component: Sorry,
      },
      {
          path: '/time_passed',
          name: 'time_passed',
          component: Time_passed,
      },


    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})

router.beforeEach((to,from, next)=>{


    if(to.name === 'gate' || to.name === 'root'){
        let urlParams = new URLSearchParams(window.location.search);
        if(urlParams.has('st')){
            let default_state = urlParams.get('st');
            store.commit('default_state', default_state)
        }
        console.log('before each');
        if(urlParams.has('sweeps')){
            console.log('has sweep param');
            let default_sweeps = urlParams.get('sweeps');
            console.log('param', default_sweeps);
            store.commit('default_sweeps', default_sweeps)
        }
    }

    if(store.state.passed_stages.indexOf(to.name) !== -1 && to.name !== store.state.active_view && store.state.block_navigate){
        next({name: 'sorry'})
    }

    if (from.name === 'game_play_regular' && store.getters.game_type !== '' && store.state.allowed_stages.indexOf(store.getters.game_type) === -1) {
        store.commit('push_to_allowed_stages', store.getters.game_type)
        next({name: store.getters.game_type})
    }
    else {

        if (store.state.allowed_stages.indexOf(to.name) === -1) {
            next({name: store.state.start_point})
        } else {
            next()
        }

    }


})

router.afterEach((to,from)=>{
    if(to.name !== 'root'){

        if(to.name !== 'sorry'){
            store.commit('save_data',{key: 'active_view', data: to.name})
        }

        if(to.name !== 'rules' && to.name !== 'sorry' && to.name !== 'time_passed'){
            store.commit('push_to_passed_stages', to.name)
        }

    }
})

export default router;